import React, { useState } from "react";
import "./App.css";

import beatsaberData from "./data.json";

function App() {
  const [songName, setSongname] = useState(false);
  const [rubrikNumber, setRubrikNumber] = useState(false);
  const [enemy1, setEnemy1] = useState(false);
  const [enemy2, setEnemy2] = useState(false);

  function getRandomIntInclusive(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function getEnemies() {
    // define enemy group 1
    let newEnemy1 =
      beatsaberData.group1[
        getRandomIntInclusive(0, beatsaberData.group1.length - 1)
      ];
    setEnemy1(newEnemy1);

    // define enemy group 1
    let newEnemy2 =
      beatsaberData.group2[
        getRandomIntInclusive(0, beatsaberData.group2.length - 1)
      ];
    setEnemy2(newEnemy2);
  }

  function getSong() {
    // define packet
    let newrubrikNumber = getRandomIntInclusive(
      0,
      beatsaberData.section.length - 1
    );

    // get songname
    let newSongName =
      beatsaberData.section[newrubrikNumber].songs[
        getRandomIntInclusive(
          0,
          beatsaberData.section[newrubrikNumber].songs.length - 1
        )
      ];

    setSongname(newSongName);
    setRubrikNumber(newrubrikNumber);

    getEnemies();
  }

  return (
    <div className="main">
      <header className="header">
        <p className="title">Folgender Song wird gespielt:</p>
        {songName ? (
          <p className="result">
            {beatsaberData.section[rubrikNumber].name}: {songName}
          </p>
        ) : (
          <p className="result">...</p>
        )}

        <p className="title">Folgende Personen spielen gegeneinander:</p>
        {enemy1 ? (
          <p className="result">
            {enemy1} vs. {enemy2}
          </p>
        ) : (
          <p className="result">...</p>
        )}

        <div className="button" onClick={() => getSong()}>
          Push the Button!
        </div>
      </header>
    </div>
  );
}

export default App;
